import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PageService } from '../../services/page.service';

@Component({
  selector: 'app-highlight-detail-modal',
  templateUrl: './highlight-detail-modal.component.html',
  styleUrls: ['./highlight-detail-modal.component.scss']
})
export class HighlightDetailModalComponent implements OnInit {
  @ViewChild('dynamicComponents', { read: ViewContainerRef })
  container: ViewContainerRef;
  @Input() page;
  @Output() hideDetail: EventEmitter<any> = new EventEmitter();
  public block: any = {};
  public shareMetadata: { title?: string; image?: string } = {};
  private baseUrl = window.location.origin;
  constructor(
    private translate: TranslateService,
    private pageService: PageService
  ) {}
  ngOnInit() {
    document.body.classList.add('modal-open');
    this.pageService
      .getPage(this.page.replace('/', ''), this.translate.currentLang)
      .subscribe(
        (data: any) => {
          this.block = data;
          if (this.block.title) {
            this.shareMetadata.title = this.block.title;
          }
          if (this.block.highlight_block_image) {
            this.shareMetadata.image = this.block.highlight_block_image;
          }
          // this.dataToComponents(data);
        },
        e => {
          if (e.status > 299) {
            this.close();
          }
        }
      );
  }
  shareUrl(url: string): string {
    return `${this.baseUrl}/${this.translate.currentLang}${url}`;
  }

  close() {
    this.hideDetail.emit(false);
    window.location.hash = '';
    document.body.classList.remove('modal-open');
  }
}
